import { LabelingTypeEnum } from '../tags';

export class GatewayInput {
  id: string;

  labellingType: LabelingTypeEnum;

  fallbackValue: string;

  rawInputName: string;

  dataType: string | null;

  displayName: string | null;

  rawUnit: string | null;

  hidden: string;

  forwarded?: boolean;

  siteForwardedFrom?: string;

  gatewayForwardedFrom?: string;

  connectedAsset?: string;

  advancedTagMapping?: AdvancedTagMapping;

  maxDisplayDecimals?: number | null;

  value?: number;

  constructor(
    id: string,
    labellingType: LabelingTypeEnum,
    fallbackValue: string,
    rawInputName: string,
    dataType: string,
    displayName: string,
    rawUnit: string,
    hidden: string
  ) {
    this.id = id;
    this.labellingType = labellingType;
    this.fallbackValue = fallbackValue;
    this.rawInputName = rawInputName;
    this.dataType = dataType;
    this.displayName = displayName;
    this.rawUnit = rawUnit;
    this.hidden = hidden;
  }
}

export type AdvancedTagMapping = {
  controllerId: string;
  allowedInputs: string;
  dataTypeTagMapping: string;
  controllable: boolean;
  relevantMode: UserDefinedValue[] | string | null;
  minimumValue: number | null;
  maximumValue: number | null;
  userDefinedValues: UserDefinedValue[];
  maximumDecimal: number | null;
};

export type UserDefinedValue = {
  value: number;
  category: string | null;
  name: string | null;
  index?: number;
  gatewayId: string;
  tagId: string;
  isOperational?: boolean;
};

export type AdvancedTagMappingUpdatePayload = {
  dataType: string;
  rawInputName?: string;
  displayName: string;
  advancedTagMapping: AdvancedTagMappingPayload | null;
};

export type RelevantModeResponseBody = {
  displayName: string;
  minimumValue: number;
  maximumValue: number;
  tagId: string;
  userDefinedValues: UserDefinedValue[];
};

export type AdvancedTagMappingPayload = {
  controllerId: string;
  allowedInputs: string;
  dataTypeTagMapping: string;
  controllable: boolean;
  relevantMode: UserDefinedValue[] | string | null;
  minimumValue: number | null;
  maximumValue: number | null;
  userDefinedValues: UserDefinedValue[];
};

export type GatewayOptionsTypes =
  | 'FX30'
  | 'Inhand'
  | 'Ewon'
  | 'STREAM-Lite'
  | 'StreamMLite'
  | 'Kallipr';

export enum GatewayOptionsEnum {
  FX30 = 'FX30',
  Inhand = 'Inhand',
  Ewon = 'Ewon',
  StreamLite = 'STREAM-Lite',
  StreamMLitePayload = 'StreamMLite',
  Kallipr = 'Kallipr',
}

export enum GatewayInputDataTypeEnum {
  ALARM = 'alarm',
  MODE = 'mode',
  STATE = 'state',
  SENSOR_DATA = 'sensor_data',
  OUTPUT = 'output',
  SETPOINT = 'setpoint',
  CALCULATED = 'calculated',
  NULL = '',
}
